module.exports = __webpack_public_path__ + "img/NF.8b3e0ad9.svg";